import React from 'react';

function InputData({data, handleAdd, handleRemove, handleInputChange, types, type, mode}) {
    return (
        <>
            {data.length!==0 && data.map((item, index) => (
                <div className="row pt-2" key={index}>
                    <div className='row'>
                    {(data[index].PhoneNo !== undefined || data[index].PhoneNumber !== undefined)? (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <input
                                            placeholder="Xxx"
                                            value={item.PhoneNo || item.PhoneNumber}
                                            onChange={(event) => handleInputChange(event, index, 'PhoneNo')}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (<></>)}

                        {data[index].Email !== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <input
                                            placeholder="Email"
                                            value={item.Email}
                                            onChange={(event) => handleInputChange(event, index, 'Email')}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {data[index].Name!== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <input
                                            placeholder="Name"
                                            value={item.Name}
                                            onChange={(event) => handleInputChange(event, index, 'Name')}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {data[index].ReferenceNo!== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <input
                                            placeholder="Name"
                                            value={item.ReferenceNo}
                                            onChange={(event) => handleInputChange(event, index, 'ReferenceNo')}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {types && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <select
                                            className="ddselect"
                                            name="type"
                                            id="type"
                                            onChange={(event) => handleInputChange(event, index, 'TypePOSValue')}
                                        >
                                            {types.map(({label, value}) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}
                        {index >= 0 && (
                            <div className="col-1">
                                <div className="row component">
                                    <div className="col-12 subTitle">
                                        <button className='removeTill' onClick={() => handleRemove(index)}>
                                            <img src="/Images/remove-till.png"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
            <div className='row'>
                {type==="till"?(
                    <div className={`col-lg-6 col-md-12 col-sm-12`}>
                        <div className="row component">
                            <div className="col-12 subTitle">
                                <button className='addTill' onClick={handleAdd}>
                                    + ADD ANOTHER TILL
                                </button>
                            </div>
                        </div>
                    </div>
                ):(
                    <div className={"col-lg-3 col-md-6 col-sm-12"}>
                        <div className="row component">
                            <div className="col-12 subTitle">
                                <button className='addTill' onClick={handleAdd}>
                                    + ADD ANOTHER SUPERVISOR
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
}

export default InputData;
